/* Package JSON Import will be here */
import moment from 'moment';
/* Package JSON Import will be here */

/* Project Import will be here */
import { getOrderHistory, getCancelOrderList } from "reducers/orderHistory";
import { getSalesReturnHistoryList } from "reducers/salesReturn/salesReturnHistory";
import { getRewardsHistory } from "reducers/rewards/rewardsHistory"
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    APPLY_HISTORY_FILTER: "historyFilter/APPLY_HISTORY_FILTER",
    RESET_HISTORY_FILTER: "historyFilter/RESET_HISTORY_FILTER",
};

const initialState = {
    searchText: "",
    startDate: null,
    endDate: null,
    month: null,
    monthStartDate: null,
    monthEndDate: null,
    isFilterApplied: false
};

export const historyFilter = (state = initialState, action) => {
    switch (action.type) {
        case types.APPLY_HISTORY_FILTER: {
            return {
                ...state,
                ...action.payload
            };
        }
        case types.RESET_HISTORY_FILTER: {
            return {
                ...initialState
            };
        }
        default:
            return state;
    }
};


export const applyHistoryFilter = (searchText, startDate, endDate, month, pageType) => {
    return async dispatch => {
        /* API request obj */
        let monthStartDate = null;
        let monthEndDate = null;
        if (month !== null) {
            const monthDateFormat = moment(month, Constants.YYYY_MM);
            monthStartDate = month + "-" + monthDateFormat.startOf('month').format(Constants.DD);
            monthEndDate = month + "-" + monthDateFormat.endOf('month').format(Constants.DD);
        }

        await dispatch({
            type: types.APPLY_HISTORY_FILTER,
            payload: {
                searchText: searchText,
                startDate: startDate,
                endDate: endDate,
                month: month,
                monthStartDate: monthStartDate,
                monthEndDate: monthEndDate,
                isFilterApplied: (searchText !== "" || startDate !== null || endDate !== null || month !== null) ? true : false
            }
        });

        /* Call history list API to load the data based on applied filter */
        if (pageType === Constants.ORDER_HISTORY)
            dispatch(getOrderHistory());
        else if (pageType === Constants.CANCEL_ORDER)
            dispatch(getCancelOrderList());
        else if (pageType === Constants.SALES_RETURN_HISTORY)
            dispatch(getSalesReturnHistoryList());
        else
            dispatch(getRewardsHistory());
    };
};

export const clearHistoryFilter = () => {
    return async (dispatch) => {
        await dispatch({ type: types.RESET_HISTORY_FILTER });
    };
}

export const resetHistoryFilter = (pageType) => {
    return async (dispatch, getState) => {
        /* Get is filter applied already */
        const isFilterApplied = getState().historyFilter.isFilterApplied;

        /* Reset the filters */
        await dispatch({ type: types.RESET_HISTORY_FILTER });

        /* Reload the history list based on isFilterApplied */
        if (isFilterApplied) {
            if (pageType === Constants.ORDER_HISTORY)
                dispatch(getOrderHistory());
            else if (pageType === Constants.CANCEL_ORDER)
                dispatch(getCancelOrderList());
            else if (pageType === Constants.SALES_RETURN_HISTORY)
                dispatch(getSalesReturnHistoryList());
            else
                dispatch(getRewardsHistory());
        }
    };
};